import { render } from "./RegisterUserAccount.vue?vue&type=template&id=426e7029"
import script from "./RegisterUserAccount.vue?vue&type=script&lang=js"
export * from "./RegisterUserAccount.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__